import { FC } from "react";

import { SvgIconConstituentValues } from "types/common";

export const SearchBlackIcon: FC<SvgIconConstituentValues> = ({
  fill,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Placeholder" clipPath="url(#clip0_2932_13198)">
      <path
        id="Vector"
        d="M15.5 14.0001H14.71L14.43 13.7301C15.63 12.3301 16.25 10.4201 15.91 8.39014C15.44 5.61014 13.12 3.39014 10.32 3.05014C6.09001 2.53014 2.53002 6.09014 3.05002 10.3201C3.39002 13.1201 5.61002 15.4401 8.39002 15.9101C10.42 16.2501 12.33 15.6301 13.73 14.4301L14 14.7101V15.5001L18.25 19.7501C18.66 20.1601 19.33 20.1601 19.74 19.7501C20.15 19.3401 20.15 18.6701 19.74 18.2601L15.5 14.0001ZM9.50002 14.0001C7.01002 14.0001 5.00002 11.9901 5.00002 9.50014C5.00002 7.01014 7.01002 5.00014 9.50002 5.00014C11.99 5.00014 14 7.01014 14 9.50014C14 11.9901 11.99 14.0001 9.50002 14.0001Z"
        fill={fill || "#646965"}
      />
    </g>
    <defs>
      <clipPath id="clip0_2932_13198">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
